import React from 'react';
import "./assets/footer.scss"
import { useTranslation } from 'react-i18next';

export function AppFooter() {
  const {t} = useTranslation();
  const date = new Date();
    return (
        <footer className="app-footer">
            <div className="container">
                <div className="footer-bottom">
                  
                    <p>© 2021-{date.getFullYear()}  <a target="_blank" rel="noopener noreferrer" href="https://vitc.uz/"> {t("footb")}</a></p>
                </div>
            </div>
        </footer>
    );
}


